var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('l-geo-json',{ref:"refugios",attrs:{"geojson":_vm.geometrias,"options":_vm.optRefugios},on:{"ready":_vm.cargado}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }